import './App.css';
import 'antd/dist/reset.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import LoginPage from './pages/login/LoginPage';
import ResetPassword from './pages/login/ResetPassword';
import OtpVerification from './pages/login/OtpVerification';
import HomePage from './pages/HomePage';
import AdminHomePage from './pages/AdminHomePage';
import Leads from './pages/leads/Leads';
import logo from './pages/login/assets/login-illustration.png'; // adjust path if needed
import Demo from './pages/demo/Demo';
import Nurturing from './pages/nurturing/Nurturing';
import FirstInstallments from './pages/firstinstallments/FirstInstallments';
import PendingInstallments from './pages/pendinginstallments/PendingInstallments';
import Enrollments from './pages/enrollments/Enrollments';
import Profile from './pages/user/Profile';
import UpcomingBatch from './pages/upcoming/UpcomingBatch';
import DropLead from './pages/drop/DropLead';
import DemoLinks from './pages/demolinks/DemoLinks';
import PaymentLinks from './pages/demolinks/PaymentLinks';
import Users from './pages/user/Users'
import Home from './pages/Home';
import socket from './socket';
import {showLeadNotification} from './utils/notifications'

// Loader component
function Loader({ logoSrc }) {
  return (
    <div className="app-loader" role="status" aria-live="polite" aria-label="Loading">
      <div className="app-loader-inner">
        <div className="app-loader-ring" aria-hidden="true"></div>
        <img src={logoSrc} alt="Practical Infosec" className="app-loader-logo" />
      </div>
    </div>
  );
}


// Handles showing loader on route change
function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initial load
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Every time route changes
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, [location]);

   useEffect(() => {
    // Ask permission once (after login preferred)
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }

    const handleNewLead = (lead) => {
      showLeadNotification(lead);
    };

    socket.on('connect', () => {
      console.log('🟢 Socket connected');
    });

    socket.on('NEW_LEAD', handleNewLead);

    return () => {
      socket.off('NEW_LEAD', handleNewLead);
    };
  }, []);




  return (
    <>
      {loading && <Loader logoSrc={logo} />}
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/user-home/*" element={<HomePage />} />
        <Route path="/admin-home/*" element={<AdminHomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-otp" element={<OtpVerification />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/nurturing" element={<Nurturing />} />
        <Route path="/first-installments" element={<FirstInstallments />} />
        <Route path="/pending-installments" element={<PendingInstallments />} />
        <Route path="/enrollments" element={<Enrollments />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/upcoming-batch" element={<UpcomingBatch />} />
        <Route path="/drop-lead" element={<DropLead />} />
        <Route path="/demo-batch-dates" element={<DemoLinks />} />
        <Route path="/payment-links" element={<PaymentLinks />} />
        <Route path="/update-users" element={<Users />} />



      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
